import Service from "../service"
import AuthService from "../AuthService"

const Med = {
  getSearch(params) {
    return AuthService.get('/med-group', {
      params: params
    })
  },
  getSubGroup(id) {
    return AuthService.get(`/get-sub-group/${id}`);
  },
  getById(id) {
    return AuthService.get(`/med-group/${id}`)
  }
}

export default Med
